import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute} from "@angular/router";
import {ResponseHttpError, CustomMessageService, OriginMessageError, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowService} from "../../../services/api/v1/sales-workflow.service";
import {SalesWorkflowSteps} from "projects/store/src/app/enums";

@Component({
  selector: 'app-sales-advanced-contract-signing',
  templateUrl: './sales-advanced-contract-signing.component.html'
})
export class SalesAdvancedContractSigningComponent implements OnInit {
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  requestId!: string
  status: number = HttpStatusCode.Processing;
  httpResponseStatusCodes = {
    OK: HttpStatusCode.Ok,
    Processing: HttpStatusCode.Processing,
  };
  flowCode!: string;


  private readonly requestService = inject(RequestService);
  private readonly route = inject(ActivatedRoute);
  private readonly salesWorkflowService = inject(SalesWorkflowService);
  private  readonly utilService = inject(UtilService);
  private readonly customMessageService  = inject(CustomMessageService);


  ngOnInit() {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code']
    this.advancedSignAgreement(this.requestId);
  }


  advancedSignAgreement(requestId: string){
    this.utilService.enablePageLoading();
    this.requestService.advancedSignAgreement(requestId).subscribe({
      next:(resp)=>{
        if (resp.status === HttpStatusCode.Ok){
          this.status = resp.status;
        }
        this.onNextStep();

      },
      error:(err: ResponseHttpError)=>{
        this.customMessageService.responseNoticeHandler(err, OriginMessageError.BACKEND, { title: 'Encontramos un inconveniente con tu solicitud',
          message: `La solicitud no pasó las validaciones necesarias`, optionalMessage: 'Por favor, presiona el botón "Volver al inicio" para comenzar nuevamente',
          button: { label: 'Volver al inicio', routerLink: this.salesWorkflowService.getInitialPath(this.flowCode)?.routerLink},
        })
        this.status = err.status;
      }
    })
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onGotoStep() {
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit({ flowCode:this.flowCode, stepCode: SalesWorkflowSteps["review-contract"], categoryId: this.requestService.categoryId });
  }
}
